import React from 'react';

import { useTranslation } from 'react-i18next';

import { isPremierDubai } from '../../../../utils/template';

function CasinoDropdownMenu({ links, user }) {
    const { t } = useTranslation();
    const notificationsEnabled = (process.env.MIX_NOTIFICATIONS_ENABLED?.toLowerCase() === 'true');

    return (
        <div className="dropdown-menu menu-account">
           <div className="dropdown-item-wrapper">
               <a className="dropdown-item" href={links.overview}>
                   {t('userPanel.myAccount')}
               </a>
               <a className="dropdown-item" href={links.tickets}>
                   {t('userPanel.tickets')}
               </a>
               <a className="dropdown-item" href={links.bonuses}>
                   {t('userPanel.bonuses')}
               </a>
               <a className="dropdown-item" href={links.transactions}>
                   {t('userPanel.transactions')}
               </a>
               <a className="dropdown-item" href={links.deposit}>
                   {isPremierDubai() ? t('myTransactions.contributions') : t('userPanel.deposit')}
               </a>
               {notificationsEnabled && user.isReseller && (
                   <a className="dropdown-item" href={links.resellerCustomers}>
                       {t('userPanel.mySalesAccount')}
                   </a>
               )}
               <a className="dropdown-item" href={links.logout}>
                   {t('userPanel.logout')}
               </a>
           </div>
        </div>
    );
}

export default CasinoDropdownMenu;
